import { isEmpty } from 'lodash';
import { useMemo } from 'react';

import { HealthProviderFeatureItemDataFragment } from '../../../data/types/api/graphql';
import { CustomFormattedMessage } from '../../../elements/intl/custom-formatted-message';
import { HealthProviderFeatureListItem } from './health-provider-feature-list-item';

type HealthProviderFeatureListProps = {
  loading?: boolean;
  items: HealthProviderFeatureItemDataFragment[];
  onClick?: (value: HealthProviderFeatureItemDataFragment) => void;
};

export function HealthProviderFeatureList({
  loading = false,
  onClick,
  ...props
}: HealthProviderFeatureListProps) {
  const items = useMemo(() => props.items, [props.items]);

  if (loading) {
    return (
      <p>
        <CustomFormattedMessage id="common.loading" />
      </p>
    );
  }

  if (isEmpty(items)) {
    return (
      <p>
        <CustomFormattedMessage id="common.no-data" />
      </p>
    );
  }

  return (
    <div className="content-list">
      {items.map(option => (
        <div key={option.availabilityStatus} className="content-list__item">
          <HealthProviderFeatureListItem feature={option} onClick={onClick} />
        </div>
      ))}
    </div>
  );
}
